import { ClientJS } from 'clientjs';
import { version } from '../../../package.json';
import { DeviceInfo } from './types';

const client = new ClientJS();

const deviceInfo: DeviceInfo = {
	browserVersion: client.getBrowserVersion(),
	osVersion: client.getOSVersion(),
	browserFingerprint: client.getFingerprint().toString(),
	appType: 'web',
	getUserAgent: client?.getUserAgent(),
	getBrowser: client.getBrowser(),
	isChrome: client.isChrome(),
	isFirefox: client.isFirefox(),
	isSafari: client.isSafari(),
	isOpera: client.isOpera(),
	isIE: client.isIE(),
	version,
};

export default deviceInfo;